module.exports = __webpack_public_path__ + "media/day-event.png";